import { c as _c } from "react/compiler-runtime";
import { AlertCircleOutline, InfoCircleSolid } from '@byway/icons';
import clsx from 'clsx';
import type { ItineraryCardInfoBannerProps } from './ItineraryCard.types';
import styles from './ItineraryCardInfoBanner.module.css';
export function ItineraryCardInfoBanner(t0) {
  const $ = _c(12);
  const {
    children,
    variant: t1
  } = t0;
  const variant = t1 === undefined ? "plain" : t1;
  const t2 = variant !== "plain" && styles.filled;
  const t3 = variant === "error" && styles.error;
  let t4;
  if ($[0] !== t2 || $[1] !== t3) {
    t4 = clsx(styles.banner, t2, t3);
    $[0] = t2;
    $[1] = t3;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== variant) {
    t5 = <span className={styles.icon} aria-hidden={true}>{variant === "error" ? <AlertCircleOutline size="large" decorative={true} /> : <InfoCircleSolid size={variant === "plain" ? "small" : "large"} decorative={true} />}</span>;
    $[3] = variant;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== children) {
    t6 = <p className={styles.text}>{children}</p>;
    $[5] = children;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== t4 || $[8] !== t5 || $[9] !== t6 || $[10] !== variant) {
    t7 = <div className={t4} role="note" data-variant={variant}>{t5}{t6}</div>;
    $[7] = t4;
    $[8] = t5;
    $[9] = t6;
    $[10] = variant;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  return t7;
}